(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-selector"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.collection-buttons-wrapper-cps .collection-button-cps');
  const productWrapper = document.querySelector('.product-buttons-wrapper-cps');
  const allProductButtons = document.querySelectorAll('.product-buttons-wrapper-cps .product-button-cps');

  if (!productWrapper) return;
  
  // Ensure wrapper is visible
  productWrapper.style.display = 'flex';
  productWrapper.style.visibility = 'visible';
  productWrapper.style.opacity = '1';

  // Function to show/hide products based on active collection
  function filterProductsByCollection(collectionHandle) {
    if (!collectionHandle) return;
    
    // Normalize handle to lowercase for comparison
    const normalizedHandle = collectionHandle.toLowerCase().trim();
    
    let visibleCount = 0;
    allProductButtons.forEach(productBtn => {
      // Get the collection handle from data attribute (both camelCase and kebab-case work)
      const productCollectionHandle = productBtn.getAttribute('data-collection-handle');
      const normalizedProductHandle = productCollectionHandle ? productCollectionHandle.toLowerCase().trim() : '';
      
      if (normalizedProductHandle === normalizedHandle) {
        productBtn.style.display = 'inline-block'; // Explicitly set display to make it visible
        productBtn.style.visibility = 'visible';
        productBtn.style.opacity = '1';
        productBtn.style.flexShrink = '0';
        productBtn.style.whiteSpace = 'nowrap';
        visibleCount++;
      } else {
        productBtn.style.display = 'none';
      }
    });
    
    // Ensure wrapper is visible
    if (visibleCount > 0) {
      productWrapper.style.display = 'flex';
      productWrapper.style.minHeight = 'auto';
    }
    
    // Show message if no products found
    const noProductsMsg = productWrapper.querySelector('.no-products-message');
    if (visibleCount === 0 && !noProductsMsg) {
      const msg = document.createElement('p');
      msg.className = 'no-products-message';
      msg.style.cssText = 'color: #666; padding: 20px; text-align: center; width: 100%;';
      msg.textContent = 'No products available in this collection.';
      productWrapper.appendChild(msg);
      productWrapper.style.display = 'flex';
    } else if (visibleCount > 0 && noProductsMsg) {
      noProductsMsg.remove();
    }
  }

  // Find the first active button and show its products by default
  const firstActiveButton = document.querySelector('.collection-buttons-wrapper-cps .collection-button-cps.active');
  if (firstActiveButton) {
    const defaultHandle = firstActiveButton.getAttribute('data-collection-handle');
    if (defaultHandle) {
      // Small delay to ensure DOM is ready
      setTimeout(function() {
        filterProductsByCollection(defaultHandle);
      }, 100);
    }
  } else if (buttons.length > 0) {
    // If no active button, activate the first one
    const firstButton = buttons[0];
    firstButton.classList.add('active');
    const firstHandle = firstButton.getAttribute('data-collection-handle');
    if (firstHandle) {
      setTimeout(function() {
        filterProductsByCollection(firstHandle);
      }, 100);
    }
  }

  // Add click handlers to all buttons
  buttons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Remove active class from all buttons
      buttons.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Get collection handle
      const handle = this.getAttribute('data-collection-handle');
      if (!handle) return;

      // Filter products to show only from selected collection
      filterProductsByCollection(handle);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
